export class UserRoleDto {
    id: number;
    roleId: number | null;
    userId: number | null;
}